import styles from "./TwoStepPaywall.module.scss"
import FullScreenPage from "../../components/FullScreenPage/FullScreenPage"
import { useExpiration } from "../../context/expirationContext"

interface Props {
  MainPage: React.ReactNode
  WarmupPage: React.ReactNode
  disableFullScreen?: boolean
}

const TwoStepPaywall = (props: Props) => {
  return (
    <>
      {props.MainPage}
      <WarmupPaywall disableFullScreen={props.disableFullScreen}>
        {props.WarmupPage}
      </WarmupPaywall>
    </>
  )
}

interface WarmupPaywallProps extends React.PropsWithChildren {
  disableFullScreen?: boolean
}

const WarmupPaywall = (props: WarmupPaywallProps) => {
  const showWarmup = useExpiration().state.showWarmup

  const hiddenStyle = showWarmup ? "" : styles.containerHidden

  if (props.disableFullScreen) {
    return (
      <div className={`${styles.containerFlex} ${hiddenStyle}`}>
        {props.children}
      </div>
    )
  }

  return (
    <FullScreenPage
      containerClassName={`${styles.container} ${hiddenStyle}`}
      addInsetPadding
    >
      {props.children}
    </FullScreenPage>
  )
}

export default TwoStepPaywall
